export enum GraphTypeEnum {
  histogramme = 'Histogramme',
  barreEmpilee = 'Barre empilée',
  camembert = 'Camembert'
}
